import { render, staticRenderFns } from "./ParticipantFilterBar.vue?vue&type=template&id=45537195"
import script from "./ParticipantFilterBar.vue?vue&type=script&lang=ts"
export * from "./ParticipantFilterBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports